import { StateSchema } from 'app/config/storeConfig/types';
import { City } from 'entities/City';

export const getSelectedCity = (state: StateSchema): Nullable<City> => state.createWarehouseModal.selectedCity;
